import React from 'react'

interface AppCardProps extends React.HTMLAttributes<HTMLDivElement> {
  selected?: boolean
  interactive?: boolean
}

export const AppCard = React.forwardRef<HTMLDivElement, AppCardProps>(function AppCard(
  { selected = false, interactive = false, className = '', children, style, ...rest },
  ref
) {
  const base = [
    'bg-[color:var(--surface)]',
    'rounded-[var(--radius-card)]',
    'border',
    selected
      ? 'border-[color:var(--accent)] ring-2 ring-[color:var(--accent)]/20'
      : 'border-[color:var(--border)]',
    interactive ? 'cursor-pointer transition-all duration-150 hover:border-[color:var(--border-strong)]' : '',
    className,
  ].join(' ')

  return (
    <div
      ref={ref}
      className={base}
      style={{ boxShadow: 'var(--shadow-card)', ...style }}
      {...rest}
    >
      {children}
    </div>
  )
})

export default AppCard
